import { Language, Messages } from './Language'
import { Constants } from '@core/Utils/Constants'
import { Phase } from '@core/Logic/Logic'
import { Client } from '@core/Client';

export class ProgressBar extends Phaser.GameObjects.Container {
	public mainText: Phaser.GameObjects.Text;
	public barHeight: number;

	private maxWidth = 0
	private currentProgressBarValue: number
	private progressBarTargetValue: number

	private primaryTimeout: any;

	private displayingLongText: boolean = false;
	private lastSentMessage;
	private storedText;

	constructor(scene: Phaser.Scene, stageWidth: number, private bar: IProgressBar, private externalTextObject: Phaser.GameObjects.Text = null) {
		super(scene, 0, 0)
		this.maxWidth = stageWidth
		this.currentProgressBarValue = this.progressBarTargetValue = 0;

		this.barHeight = 0;

		this.add(this.bar.GameObject)

		if (externalTextObject == null) {
			this.mainText = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(Messages.WAITING), { ...Constants.PROGRESS_BAR.FONT, fontSize: Math.max(this.barHeight * Constants.PROGRESS_BAR.RELATIVE_FONT_SIZE, 1).toString() + 'px', stroke: "#000", strokeThickness: 2 })
			this.mainText.x = scene.scale.width / 2;
			this.mainText.setOrigin(0.5, 0);
			this.add(this.mainText)
		}
		else {
			this.mainText = externalTextObject;
		}

		//recovery on start happens too soon, so we check here if there is something to recover.
		if (Client.logic.CurrentWinNumber != -1 && Client.logic.Phase == Phase.READING_WIN_NUMBER_STATE)
			this.mainText.text = Client.logic.generateWinNumberText(Client.logic.CurrentWinNumber);

		Client.game.events.on(Constants.EVENTS.UPDATE_MAIN_TEXT, (a: any, historic: boolean = false, historyText: any) => { this.onUpdateMainText(a, historic, historyText); })

		Client.game.events.on(Constants.EVENTS.PROGRESSBAR, (a: number, force: boolean = false) => { this.UpdateProgressBar(a, force) })
	}

	Update(time: number) {
		// asimptotično približevanje
		let delta = (this.progressBarTargetValue - this.currentProgressBarValue)

		time = time * 0.001 + 1
		this.currentProgressBarValue += delta * (1 - 1 / (1.0 + Constants.PROGRESS_BAR.TIME_CONSTANT * time * Math.log(time)));
		// this.bar.width = this.currentProgressBarValue * this.maxWidth
		this.bar.SetCurrentWidth(this.currentProgressBarValue * this.maxWidth)
	}

	UpdateProgressBar(newValue: number, force: boolean = false): void {

		this.progressBarTargetValue = newValue
		if (force) {
			this.currentProgressBarValue = this.progressBarTargetValue
		}
	}

	UpdatePositions(width: number, height: number): void {
		this.scale = 1;

		if (!this.externalTextObject) {
			if (this.lastSentMessage && !Array.isArray(this.lastSentMessage)) {
				this.mainText.text = Language.Get(this.lastSentMessage);
			}

			this.mainText.scale = 1;

			this.barHeight = height;
			this.height = this.barHeight;
			this.maxWidth = width;

			this.bar.ResizeBar(width, this.barHeight);

			this.resizeTexts(width)
		} else {
			this.maxWidth = width;
			let actualBarHeight = this.bar.ResizeBar(width, this.barHeight);
			// Secondary resize due to repositioning of the parent
			this.bar.ResizeBar(width, this.barHeight);

			if (this.lastSentMessage && !Array.isArray(this.lastSentMessage)) {
				this.externalTextObject.text = Language.Get(this.lastSentMessage);
			}
		}
	}

	private resizeTexts(w: number): void {
		if (this.externalTextObject)
			return;

		let sideMargin = w * Constants.PANEL.MARGIN;

		this.mainText.style.setFontSize(this.barHeight * 1.5 * Constants.PROGRESS_BAR.RELATIVE_FONT_SIZE);
		this.mainText.x = w / 2
		this.mainText.y = (0.45 - Constants.PROGRESS_BAR.RELATIVE_FONT_SIZE) / 2 * this.barHeight;
	}

	private onUpdateMainText(a: any, historic: boolean = false) {
		this.lastSentMessage = a;

		//Clear all timeouts on update if they exist
		if (this.primaryTimeout && (Array.isArray(a) || !this.displayingLongText || historic)) {
			clearTimeout(this.primaryTimeout);
			this.primaryTimeout = null;
			this.displayingLongText = false;
		}

		if (Array.isArray(a)) {
			let readyForDisplayText: Array<any> = new Array<any>();
			let str = "";

			a.forEach((text, index) => {
				let t = Language.Get(text);
				if (str.length + 7 + t.length > 90) {
					readyForDisplayText.push(str);
					str = "";
				}
				else if (str.length > 0)
					str += "   |   ";

				str += t;

				if (a.length == (index + 1))
					readyForDisplayText.push(str);
			});

			if (readyForDisplayText.length == 1) {
				this.mainText.text = Language.Get(readyForDisplayText[0]);
			}
			else {
				this.displayingLongText = true;
				let i = 1;
				this.mainText.text = Language.Get(readyForDisplayText[0]);
				this.primaryTimeout = setInterval(function () {
					this.mainText.text = Language.Get(readyForDisplayText[i]);
					i++;

					if (i >= readyForDisplayText.length || historic) {
						this.displayingLongText = false;

						if (this.storedText && this.storedText.length > 0) {
							this.mainText.text = Language.Get(this.storedText);
							this.mainText.x = this.maxWidth / 2;
							this.storedText = "";
						}

						clearTimeout(this.primaryTimeout);
					}
				}.bind(this), (3000));
			}

		}
		else {
			if (!this.displayingLongText) {
				this.mainText.text = Language.Get(a);
			}
			else {
				this.storedText = a;
			}
		}

		this.mainText.x = this.maxWidth / 2;
	}
}

export class Bar extends Phaser.GameObjects.Graphics implements IProgressBar {

	private barHeight = 0

	constructor(scene: Phaser.Scene, private maxBarWidth: number, public barColor: number, private barBackColor: number, private currentBarPos: number) {
		super(scene)
	}

	get GameObject(): Phaser.GameObjects.GameObject {
		return this
	}

	set width(width: number) {
		this.SetCurrentWidth(width)
	}

	SetCurrentWidth(width: number): void {
		this.currentBarPos = width;
		this.clear()
		this.fillStyle(this.barBackColor, 1)
		this.fillRect(this.x, this.y, this.maxBarWidth, this.barHeight)
		this.fillStyle(this.barColor, 1)
		this.fillRect(this.x + this.maxBarWidth - this.currentBarPos, this.y, this.currentBarPos, this.barHeight)
	}

	ResizeBar(w: number, h: number): number {
		let rel = this.currentBarPos / this.maxBarWidth
		this.barHeight = h;
		this.maxBarWidth = w
		this.SetCurrentWidth(rel * w)
		return this.barHeight
	}
}

export class ImageBar extends Phaser.GameObjects.Container implements IProgressBar {
	protected progressBarImage: Phaser.GameObjects.Image
	protected notch: Phaser.GameObjects.Image
	protected barHeight = 0

	private barMask: Phaser.Display.Masks.GeometryMask
	private shape: Phaser.GameObjects.Graphics

	constructor(scene: Phaser.Scene, protected maxBarWidth: number, protected currentBarPos: number, protected spriteSheet: string = Constants.SPRITESHEET) {
		super(scene)

		this.progressBarImage = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, "TimeBar.png")
		this.progressBarImage.setOrigin(0)
		this.add(this.progressBarImage)

		this.notch = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, "TimeBarNotch.png");
		this.notch.setVisible(false);
		this.add(this.notch);

		// Shape for mask creation
		this.shape = new Phaser.GameObjects.Graphics(scene)

		this.barMask = this.shape.createGeometryMask()
		this.progressBarImage.setMask(this.barMask)
	}

	get GameObject(): Phaser.GameObjects.GameObject {
		return this
	}

	SetCurrentWidth(width: number): void {
		this.currentBarPos = width;
		this.shape.clear();
		this.shape.setPosition(0, this.parentContainer.y)
		this.shape.fillStyle(0xffffff);
		this.shape.fillRect(this.x + this.maxBarWidth - this.currentBarPos, this.y, this.currentBarPos, this.progressBarImage.displayHeight)

		this.notch.x = this.x + this.maxBarWidth - this.currentBarPos

		this.notch.setScale((this.progressBarImage.displayHeight * 4) / this.notch.frame.height)

		this.notch.y = 2 * this.progressBarImage.scale
	}

	ResizeBar(w: number, h: number): number {
		let rel = this.currentBarPos / this.maxBarWidth
		this.barHeight = h;
		this.maxBarWidth = w

		this.progressBarImage.setScale(w / this.progressBarImage.frame.width)
		this.progressBarImage.setPosition(0, 0)

		// 2 pixels of the bottom timebar texture should bleed over the element below
		let bottomOffset = (2 * this.progressBarImage.scale)

		this.barHeight = this.progressBarImage.displayHeight - bottomOffset

		this.SetCurrentWidth(rel * w)
		// console.log(this.parentContainer.y) // a(0,214) je deloval na fullscreen 1920x1200
		return this.barHeight
	}
}

export class AnimatedImageBar extends ImageBar {
	private animatedNotch: Phaser.GameObjects.Sprite

	constructor(scene: Phaser.Scene, maxBarWidth: number, currentBarPos: number, protected spriteSheet: string = Constants.SPRITESHEET) {
		super(scene, maxBarWidth, currentBarPos, spriteSheet)

		scene.anims.create({
			key: "PROGRESSBAR_NOTCH_ANIM",
			frames: scene.anims.generateFrameNames("spark", {
				start: 0,
				end: 23,
				suffix: ".png"
			}),
			frameRate: 24,
			repeat: -1
		})

		this.animatedNotch = new Phaser.GameObjects.Sprite(scene, 0, 0, "spark");
		this.animatedNotch.setBlendMode(Phaser.BlendModes.ADD);
		this.animatedNotch.play("PROGRESSBAR_NOTCH_ANIM")
		this.animatedNotch.addToUpdateList();
		this.add(this.animatedNotch)
	}

	SetCurrentWidth(width: number): void {
		super.SetCurrentWidth(width)
		this.animatedNotch.setScale(this.notch.scale /* * 0.50 */)
		this.animatedNotch.setPosition(this.x + this.maxBarWidth - this.currentBarPos, 2 * this.progressBarImage.scale * 2.50)
		this.animatedNotch.setScale(this.notch.scale * Math.min(Math.sqrt(this.currentBarPos * 0.10), 1))
		this.animatedNotch.angle += 1
	}
}

interface IProgressBar {
	readonly GameObject: any
	SetCurrentWidth(width: number): void
	ResizeBar(width: number, height: number): number
}
